import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Icon from '../Icon';
import Box from '../Box';
import Text from '../Text';
import Button from '../Button';

const NavigationHeader = (props) => {
  const {
    title,
    onClickIcon,
    headerLocation,
    styleIcon,
    buttonBack,
    showFilterIcon,
    showClearAll,
    buttonClearAll,
    buttonClearLabelKey,
    onClickIconClearAll,
    focusBehavior = false
  } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const backButtonRef = React.useRef(null);

  React.useEffect(() => {
    if (backButtonRef.current && focusBehavior) {
      setTimeout(() => {
        backButtonRef.current.focus();
      }, 50);
    }
  }, [focusBehavior]);
  return (
    <Box
      display="flex"
      alignItems="center"
      borderBottom
      marginBottom="3"
      paddingBottom="2"
      fontSize="6"
      className={className}
      style={style}
    >
      <Button
        {...buttonBack}
        focusReferences={backButtonRef}
        onClick={onClickIcon}
        onKeyDown={($event) => {
          if ($event.keyCode === 13) {
            onClickIcon();
          }
        }}
        dataTestId="iconKeyboardArrowDown"
      >
        <Icon rotate fontSize="4" style={styleIcon} icon="keyboard_arrow_down" />
      </Button>
      {/* TODO: Remove this Line */}
      {showFilterIcon && <Icon rotate fontSize="4" paddingLeft="2" icon="settings" />}
      <Text flex="1" {...headerLocation}>
        {title}
      </Text>
      {/* TODO: Putting the button to clean all provicional by airBnb */}
      {showClearAll && (
        <Button
          {...buttonClearAll}
          onClick={onClickIconClearAll}
          onKeyDown={($event) => {
            if ($event.keyCode === 13) {
              onClickIconClearAll();
            }
          }}
          dataTestId="buttonClearAll"
        >
          <Text>{translate(buttonClearLabelKey, 'Clear all')}</Text>
        </Button>
      )}
    </Box>
  );
};

NavigationHeader.propTypes = {
  /**
   * Title of the Top Bar
   */
  title: PropTypes.string,
  /**
   * Handle when click on the icon
   */
  onClickIcon: PropTypes.func,
  /**
   * Styles of the area where the text is displayed
   */
  headerLocation: PropTypes.objectOf(PropTypes.any),
  /**
   * Styles of the icon
   */
  styleIcon: PropTypes.objectOf(PropTypes.any),
  /**
   * Settings of buttonBack
   */
  buttonBack: PropTypes.objectOf(PropTypes.any),
  showFilterIcon: PropTypes.bool,
  showClearAll: PropTypes.bool,
  buttonClearAll: PropTypes.objectOf(PropTypes.any),
  buttonClearLabelKey: PropTypes.string,
  onClickIconClearAll: PropTypes.func
};
NavigationHeader.defaultProps = {
  title: '',
  onClickIcon: null,
  headerLocation: {},
  styleIcon: {},
  buttonBack: {
    bgColor: 'white',
    padding: '0',
    paddingTop: '1',
    borderNone: true,
    tabIndex: 0
  },
  showFilterIcon: false,
  showClearAll: false,
  buttonClearAll: {
    color: 'link',
    bgColor: 'transparent',
    borderNone: true,
    fontSize: '3',
    textTransform: 'uppercase'
  },
  buttonClearLabelKey: 'cmp-filter-clear',
  onClickIconClearAll: () => {}
};

export default NavigationHeader;
